var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Button',{nativeOn:{"click":function($event){return _vm.click()}}},[_c('NewTranslation',{attrs:{"path":"booking.addTaxcard.label"}}),_c('font-awesome-icon',{attrs:{"slot":"icon","icon":"plus"},slot:"icon"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }